import {
  calcLi,
  calcRdi,
  calcRemainingBemessungslast,
  calcRsdi,
  calcSumLi,
  calcSumRsd,
  calcSumRsdi,
  calcTi,
  calcTiBeta,
} from "./berechneSchichten.service";

export function berechneSchichten(props) {
  const {
    schichtenInput,
    bohrkronendurchmesser,
    teilsicherheitsbeiwert,
    modellfaktor,
    pfahlneigungZurVertikalen,
    bemessungslast,
  } = props;

  let remainingBemessungslast = Number(bemessungslast);
  let schichten = [];
  let sumLi = 0;
  let sumRsdi = 0;
  let sumRsd = 0;

  for (let index = 0; index < schichtenInput.length; index++) {
    const element = schichtenInput[index];

    // Make some Numbers :)
    let bisNumber = Number(element.bis);
    let vonNumber = Number(element.von);
    let qskiNumber = Number(element.qski);
    let aNumber = Number(element.a);

    // Rdi
    let Rdi = calcRdi(
      bemessungslast,
      bohrkronendurchmesser,
      teilsicherheitsbeiwert,
      modellfaktor,
      qskiNumber,
      aNumber
    );

    // ti
    let Ti = calcTi(vonNumber, bisNumber);

    // Li
    let Li = calcLi(Rdi, Ti, pfahlneigungZurVertikalen, remainingBemessungslast);

    // Rsdi
    let Rsdi = calcRsdi(Rdi, Li);

    // TiBeta
    let TiBeta = calcTiBeta(Ti, pfahlneigungZurVertikalen);

    // Fd,Rest
    remainingBemessungslast = calcRemainingBemessungslast(remainingBemessungslast, Li, Rdi);

    // rsd
    sumRsd = calcSumRsd(
      sumRsd,
      bohrkronendurchmesser,
      aNumber,
      Li,
      qskiNumber,
      teilsicherheitsbeiwert,
      modellfaktor
    );

    // update Tables Result Sums
    sumLi = calcSumLi(sumLi, Li);
    sumRsdi = calcSumRsdi(sumRsdi, Rsdi);

    let resultSchicht = {
      index: index,
      rdi: Rdi,
      liZeta: Li,
      rsdi: Rsdi,
      fdRest: remainingBemessungslast,
      ti: TiBeta,
    };

    schichten.push(resultSchicht);
  }

  return {
    schichten,
    resultSumLi: sumLi,
    resultSumRsdi: sumRsdi,
    bemessungspfahlwiderstand: sumRsd,
  };
}
